<template>
    <div class="mb-4">
        <strong>When will this message be sent</strong>

        <div v-if="template_context === 'wine-club-new-membership'">
            <ul>
                <li>Within two hours after the creation of a new club membership, RedChirp will send this message</li>
                <li>The message will be sent to every phone number associated with the member's customer profile</li>
                <li>The message will only sent once per day per phone number &mdash; therefore, if someone joins more than one club on the same day they will only receive this message once</li>
            </ul>
        </div>

        <div v-if="template_context === 'wine-club-join-follow-up'">
            <ul>
                <li>RedChirp will trigger this message after the specified (customizable) number of days after a member signs up for a club</li>
                <li>The membership must be active on the day in question</li>
                <li>The message will be sent to every phone number associated with the member's customer profile</li>
                <li>The message will only sent once per day per phone number &mdash; therefore, if someone has more than one club join follow up on the same day they will only receive this message once</li>
                <li>RedChirp generates these messages gradually between 9:00 AM and 2:00 PM each day</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WineClubMessageInfo',

    props: {
        template_context: {
            type: String,
            required: true
        }
    }
}
</script>
